import React, { useState } from "react";
import { SendBusBookingNotifications } from "../../Services/BusAPI";

const BusEmailTicket = ({ referenceNo, trackId }) => {
  const [emailAddress, setEmailAddress] = useState("");
  const [emailPricing, setEmailPricing] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClickEmail = async () => {
    if (!emailAddress) {
      alert("Please enter email address");
      return;
    }

    // if (!emailPricing) {
    //   alert("Please select a pricing option");
    //   return;
    // }

    try {
      setLoading(true);

      const payload = {
        referenceNo: referenceNo,
        trackId: trackId,
        communicationType: "Email",
        communicationOn: emailAddress,
        pricingOption: emailPricing,
        clientCode: "BerryJourneys"
      };

      console.log("SendFlightBookingNotifications", payload);
      const response = await SendBusBookingNotifications(payload);
    
      if (response ==="Mail triggered successfully" || response ==="Success") {
          alert(`Email sent successfully on ${emailAddress}`);
        setEmailAddress("");
        setEmailPricing("");
        //window.location.reload();
      } else {
        //alert("Failed to send email.");
      }
    } catch (error) {
      console.error("Email Error:", error);
      alert("Something went wrong while sending email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="form_row">
          <label className="required">Enter Email Address</label>
          <input
            type="email"
            className="form-control"
            placeholder="Enter Email Address..."
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
          />
        </div>
      </div>

      {/* <div className="col-md-12 mt-3">
        <p>Select Desired Pricing Option (you can select only one option)</p>

        <div className="d-flex">
          <div className="form-check m-3">
            <input
              type="radio"
              className="form-check-input"
              id="emailRadio1"
              name="emailPricing"
              value="withPrice"
              checked={emailPricing === "withPrice"}
              onChange={(e) => setEmailPricing(e.target.value)}
            />
            <label className="form-check-label" htmlFor="emailRadio1">
              With Price
            </label>
          </div>

          <div className="form-check m-3">
            <input
              type="radio"
              className="form-check-input"
              id="emailRadio2"
              name="emailPricing"
              value="withoutPrice"
              checked={emailPricing === "withoutPrice"}
              onChange={(e) => setEmailPricing(e.target.value)}
            />
            <label className="form-check-label" htmlFor="emailRadio2">
              Without Price
            </label>
          </div>

          <div className="form-check m-3">
            <input
              type="radio"
              className="form-check-input"
              id="emailRadio3"
              name="emailPricing"
              value="hideMarkup"
              checked={emailPricing === "hideMarkup"}
              onChange={(e) => setEmailPricing(e.target.value)}
            />
            <label className="form-check-label" htmlFor="emailRadio3">
              Hide Markup
            </label>
          </div>
        </div>
      </div> */}

      <div className="col-md-12 text-end">
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleClickEmail}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Email"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusEmailTicket;
